import { render, staticRenderFns } from "./OverrideCard.vue?vue&type=template&id=11a4bf46&"
import script from "./OverrideCard.vue?vue&type=script&lang=js&"
export * from "./OverrideCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11a4bf46')) {
      api.createRecord('11a4bf46', component.options)
    } else {
      api.reload('11a4bf46', component.options)
    }
    module.hot.accept("./OverrideCard.vue?vue&type=template&id=11a4bf46&", function () {
      api.rerender('11a4bf46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/Overrides/OverrideCard.vue"
export default component.exports